import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Close from "@mui/icons-material/Close";
import { Grid, IconButton, useTheme } from "__barrel_optimize__?names=Grid,IconButton,useTheme!=!@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { tokens } from "../theme";
import ReusableButton from "./ReusableButton";
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 550,
    width: "95%",
    bgcolor: "background.paper",
    boxShadow: 24,
    outline: "none",
    p: "30px",
    borderRadius: "12px"
};
export default function ConfirmationModal(param) {
    let { children, open, handleClose, title, subtitle, primaryBtnName, secondaryBtnName, isDelete, primaryBtnAction, secondaryBtnAction, hideCloseIcon, primaryBtnLoading, primaryBtnDisabled, primaryBtnLoadingText, secondaryBtnLoading, secondaryBtnDisabled, secondaryBtnLoadingText } = param;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        onClose: handleClose,
        closeAfterTransition: true,
        slots: {
            backdrop: Backdrop
        },
        slotProps: {
            backdrop: {
                timeout: 500
            }
        },
        children: /*#__PURE__*/ _jsx(Fade, {
            in: open,
            children: /*#__PURE__*/ _jsxs(Box, {
                position: "relative",
                sx: style,
                children: [
                    !hideCloseIcon && /*#__PURE__*/ _jsx(IconButton, {
                        style: {
                            position: "absolute",
                            top: "15px",
                            right: "15px"
                        },
                        onClick: handleClose,
                        children: /*#__PURE__*/ _jsx(Close, {})
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        component: "h2",
                        fontSize: "22px",
                        fontWeight: "700",
                        pb: "15px",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "inherit",
                        fontWeight: "500",
                        fontSize: "14px",
                        pb: "20px",
                        sx: {
                            wordWrap: "break-word",
                            overflowWrap: "break-word"
                        },
                        children: subtitle
                    }),
                    children && children,
                    /*#__PURE__*/ _jsx(Box, {
                        mt: "20px",
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            container: true,
                            width: "100%",
                            spacing: !secondaryBtnName ? 0 : 2,
                            children: [
                                secondaryBtnName && /*#__PURE__*/ _jsx(Grid, {
                                    xs: 12,
                                    sm: 6,
                                    item: true,
                                    children: /*#__PURE__*/ _jsx(ReusableButton, {
                                        backgroundColor: colors.button.secondary,
                                        backgroundColorOnHover: colors.button.secondaryOnHover,
                                        color: "#FFF",
                                        name: secondaryBtnName,
                                        width: "100%",
                                        fontSize: "16px",
                                        onClick: secondaryBtnAction && secondaryBtnAction,
                                        disabled: Boolean(secondaryBtnDisabled) || Boolean(secondaryBtnLoading),
                                        loading: Boolean(secondaryBtnLoading),
                                        loadingText: secondaryBtnLoadingText
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Grid, {
                                    xs: 12,
                                    sm: !secondaryBtnName ? 12 : 6,
                                    item: true,
                                    children: /*#__PURE__*/ _jsx(ReusableButton, {
                                        backgroundColor: isDelete ? colors.button.danger : colors.button.main,
                                        backgroundColorOnHover: isDelete ? colors.button.dangerOnHover : colors.button.mainOnHower,
                                        color: "#FFF",
                                        name: primaryBtnName,
                                        width: "100%",
                                        fontSize: "16px",
                                        onClick: primaryBtnAction,
                                        disabled: Boolean(primaryBtnDisabled) || Boolean(primaryBtnLoading),
                                        loading: Boolean(primaryBtnLoading),
                                        loadingText: primaryBtnLoadingText
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
